import React from 'react';
import SearchForm from './components/search-form';
import ResultsSection from './components/results-section';
import ResultsNotification from './components/results-notification';

const MainPage = () => (
  <>
    <SearchForm />
    <ResultsSection />
    <ResultsNotification />
  </>
);

export default MainPage;
